interface StepIndicatorProps {
  current: number
  total: number
  stepLabel: string
}

export function StepIndicator({ current, total, stepLabel }: StepIndicatorProps) {
  const pct = (current / total) * 100

  return (
    <div data-testid="step-indicator" className="space-y-1.5">
      <p className="text-xs text-slate-500">
        Step <span className="font-medium text-deep-ink">{current}</span> / {total}
        <span className="mx-1.5 text-slate-300">—</span>
        <span className="text-deep-ink">{stepLabel}</span>
      </p>
      <div className="h-1 w-full bg-soft-panel rounded-full overflow-hidden">
        <div
          className="h-1 bg-echo-indigo rounded-full transition-all duration-300"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  )
}
